// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h5 {
  font-size: 1rem;
  padding: 0;
  margin: 0;
}

.dayBox {
  height: 35px;
}

.yearDayBox {
  float: left;
  text-align: center;
  padding: 3px;
  width: 14%;
  height: 35px;
}

.monthEvent {
  min-height: 30px;
}

.dayInMonthEvents {
  min-height: 85px;
}

.dayInMonthEvents {
  max-height: 180px;
  overflow-y: scroll;
}

.dayInMonthEvents::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

.dayInMonthEvents::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
  border-radius: 1px;
}

.dayInMonthEvents::-webkit-scrollbar-thumb {
  border-radius: 1px;
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);
}

.monthBox {
  clear: both;
  display: block;
  margin: 0;
}

.marked {
  border: 1px solid #0b3e6f;
}

.notfree {
  background: -webkit-linear-gradient(360deg, #B22859, #8E1339);
}

.notfreeLong {
  background: -webkit-linear-gradient(360deg, #28B259, #138E39);
}

.notfreeNext {
  background: -webkit-linear-gradient(360deg, #f8f8f8, #a8a8a8);
}

.mainImage {
  clear: both;
  height: 200px;
  display: block;
  margin: 0 auto;
}

.hours .item-md .item-button.notfree {
  font-size: 4.4rem;
  padding: 30px;
  background: -webkit-linear-gradient(360deg, #B22859, #8E1339);
}

.hours .item-md .item-button.free {
  font-size: 4.4rem;
  padding: 30px;
  background: -webkit-linear-gradient(360deg, #28B259, #138E39);
}

.hours ion-label span {
  font-size: 3rem;
}

.hours ion-label {
  font-size: 6rem;
}

.hour {
  width: 100%;
  border-radius: 3px;
  border-bottom: 1px solid #dfdfdf;
}

@media only screen and (max-width: 1050px) {
  .hour h3, .hour h4 {
    padding: 0px;
    margin: 0px;
  }
  .mainImage {
    width: auto;
    height: 50px;
  }
  .hours ion-label {
    font-size: 3rem;
  }
  .hours .item-md .item-button.free {
    font-size: 1.4rem;
  }
}
.boxes {
  background-color: white;
}

.dayInMonthConteiner {
  display: flex;
}

.dayInMonth {
  padding: 1px;
  flex: 1 1 0px;
}

.smallLineHeight {
  line-height: 2px;
}

.weekContainer > div:nth-of-type(odd) {
  background: #f2f2f2;
}

.weekContainer > div:nth-of-type(even) {
  background: #ffffff;
}

.dayInMonthConteiner2 > div:nth-of-type(odd) {
  background: #f8f8f8;
}

.dayInMonthConteiner2 > div:nth-of-type(even) {
  background: #ffffff;
}

.dayInMonthConteiner {
  background: #dadada;
}

.dayInMonthConteiner2 {
  border-top: 1px solid #cacaca;
}

.dayInMonthFlat {
  max-width: 150px;
}

.borderLeftTransition {
  transition: border-left-width 0.1s ease-in-out;
}

.onHoverChooseEvent:hover {
  background: #0b3e6f;
}

.dropEvent .dropEventSon {
  visibility: hidden;
}

.dropEvent:hover .dropEventSon {
  visibility: visible;
}

.highlightEvent {
  background: var(--ion-color-warning);
}

.dayInMonthConteiner2 > .cantChooseDate {
  background: #c5c5c5 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/calendar/minicalendar/minicalendar.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,UAAA;EACA,SAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;AACF;;AAEA;EAEE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,kBAAA;AAAF;;AAKA;EACE,UAAA;EACA,WAAA;AAFF;;AAKA;EACE,oDAAA;EACA,kBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,oDAAA;AAFF;;AAMA;EACE,WAAA;EACA,cAAA;EACA,SAAA;AAHF;;AAOA;EAEE,yBAAA;AALF;;AAQA;EACE,6DAAA;AALF;;AAQA;EACE,6DAAA;AALF;;AAQA;EACE,6DAAA;AALF;;AAQA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;AALF;;AAQA;EACE,iBAAA;EACA,aAAA;EACA,6DAAA;AALF;;AAQA;EACE,iBAAA;EACA,aAAA;EACA,6DAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAOA;EACE,WAAA;EACA,kBAAA;EACA,gCAAA;AAJF;;AAOA;EAEE;IACE,YAAA;IACA,WAAA;EALF;EAWA;IACE,WAAA;IACA,YAAA;EATF;EAYA;IACE,eAAA;EAVF;EAaA;IACE,iBAAA;EAXF;AACF;AAcA;EACE,uBAAA;AAZF;;AAeA;EACE,aAAA;AAZF;;AAeA;EAEE,YAAA;EACA,aAAA;AAbF;;AAmBA;EAEE,gBAAA;AAjBF;;AAsBA;EACE,mBAAA;AAnBF;;AAsBA;EACE,mBAAA;AAnBF;;AAqBA;EACE,mBAAA;AAlBF;;AAqBA;EACE,mBAAA;AAlBF;;AAqBA;EAEE,mBAAA;AAnBF;;AAsBA;EAEE,6BAAA;AApBF;;AAuBA;EACE,gBAAA;AApBF;;AA4BA;EAKE,8CAAA;AAzBF;;AA4BA;EACE,mBAAA;AAzBF;;AA4BA;EACE,kBAAA;AAzBF;;AA4BA;EACE,mBAAA;AAzBF;;AA2BA;EACE,oCAAA;AAxBF;;AA4BA;EACE,8BAAA;AAzBF","sourcesContent":["h5 {\n  font-size: 1rem;\n  padding: 0;\n  margin: 0;\n}\n\n.dayBox {\n  height: 35px;\n}\n\n.yearDayBox {\n  float: left;\n  text-align: center;\n  padding: 3px;\n  width: 14%;\n  height: 35px;\n}\n\n.monthEvent\n{\n  min-height: 30px;\n}\n\n.dayInMonthEvents {\n  min-height: 85px;\n}\n\n.dayInMonthEvents {\n  max-height: 180px;\n  overflow-y: scroll;\n  //line-height: 0px;\n}\n\n//scroll style\n.dayInMonthEvents::-webkit-scrollbar {\n  width: 3px;\n  height: 3px;\n}\n\n.dayInMonthEvents::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);\n  border-radius: 1px;\n}\n\n.dayInMonthEvents::-webkit-scrollbar-thumb {\n  border-radius: 1px;\n  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);\n}\n\n\n.monthBox {\n  clear: both;\n  display: block;\n  margin: 0;\n}\n\n\n.marked {\n  //background: -webkit-linear-gradient(360deg, #B22859, #8E1339);\n  border: 1px solid #0b3e6f;\n}\n\n.notfree {\n  background: -webkit-linear-gradient(360deg, #B22859, #8E1339);\n}\n\n.notfreeLong {\n  background: -webkit-linear-gradient(360deg, #28B259, #138E39);\n}\n\n.notfreeNext {\n  background: -webkit-linear-gradient(360deg, #f8f8f8, #a8a8a8);\n}\n\n.mainImage {\n  clear: both;\n  height: 200px;\n  display: block;\n  margin: 0 auto;\n}\n\n.hours .item-md .item-button.notfree {\n  font-size: 4.4rem;\n  padding: 30px;\n  background: -webkit-linear-gradient(360deg, #B22859, #8E1339);\n}\n\n.hours .item-md .item-button.free {\n  font-size: 4.4rem;\n  padding: 30px;\n  background: -webkit-linear-gradient(360deg, #28B259, #138E39);\n}\n\n.hours ion-label span {\n  font-size: 3rem;\n}\n\n.hours ion-label {\n  font-size: 6rem;\n}\n.hour {\n  width: 100%;\n  border-radius: 3px;\n  border-bottom: 1px solid #dfdfdf;\n}\n\n@media only screen and (max-width: 1050px) {\n\n  .hour h3, .hour h4 {\n    padding: 0px;\n    margin: 0px;\n  }\n  .hour {\n    //min-height: 35px;\n  }\n\n  .mainImage {\n    width: auto;\n    height: 50px;\n  }\n\n  .hours ion-label {\n    font-size: 3rem;\n  }\n\n  .hours .item-md .item-button.free {\n    font-size: 1.4rem;\n  }\n}\n\n.boxes {\n  background-color: white;\n}\n\n.dayInMonthConteiner {\n  display: flex;\n}\n\n.dayInMonth {\n  //margin: 8px;\n  padding: 1px;\n  flex: 1 1 0px;\n  //max-height: 140px;\n  //border-right: 1px solid #d4d4d4;\n  //border-bottom: 1px solid #d4d4d4;\n}\n\n.smallLineHeight\n{\n  line-height: 2px;\n}\n\n.weekContainer {\n}\n.weekContainer > div:nth-of-type(odd) {\n  background: #f2f2f2;\n}\n\n.weekContainer > div:nth-of-type(even) {\n  background: #ffffff;\n}\n.dayInMonthConteiner2 > div:nth-of-type(odd) {\n  background: #f8f8f8;\n}\n\n.dayInMonthConteiner2 > div:nth-of-type(even) {\n  background: #ffffff;\n}\n\n.dayInMonthConteiner\n{\n  background: #dadada;\n}\n\n.dayInMonthConteiner2\n{\n  border-top: 1px solid #cacaca;\n}\n\n.dayInMonthFlat {\n  max-width: 150px;\n}\n\n\n.borderLeftTransition:hover {\n  //border-left-width: 10px solid;\n}\n\n.borderLeftTransition {\n  -webkit-transition: border-left-width 0.1s ease-in-out;\n  -moz-transition: border-left-width 0.1s ease-in-out;\n  -ms-transition: border-left-width 0.1s ease-in-out;\n  -o-transition: border-left-width 0.1s ease-in-out;\n  transition: border-left-width 0.1s ease-in-out;\n}\n\n.onHoverChooseEvent:hover {\n  background: #0b3e6f;\n}\n\n.dropEvent .dropEventSon {\n  visibility: hidden;\n}\n\n.dropEvent:hover .dropEventSon {\n  visibility: visible;\n}\n.highlightEvent {\n  background: var(--ion-color-warning);\n}\n\n\n.dayInMonthConteiner2 > .cantChooseDate {\n  background: #c5c5c5 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
